module.exports = __webpack_public_path__ + "img/chart.a2833f4d.svg";